import styled from 'styled-components';
import { FormText } from 'reactstrap';

export const StyledSubHeader = styled(FormText)`
  margin-top: 0;
  margin-bottom: 10px;
`;

export const StyledLink = styled.a`
  color: blue;
  margin-left: 15px;
`;
